import { PrePopulatedTypeEnum } from '../api/model/pre-populated-type-enum';
import { TriggerEnum } from './Trigger';

export interface PrePopulatedValue {
  type?: PrePopulatedTypeEnum;
  jsonFieldId?: number | null;
  regFieldId?: number | null;
  value?: string | null;
  sourceActionRefId?: number | null;
}

export interface ActionResponse {
  type?: string | null;
  name?: string | null;
  isVisible?: boolean;
  isRequired?: boolean;
  isActionConditional?: boolean;
  parentId?: number | null;
  trigger?: TriggerEnum;
  isPrePopulated?: boolean;
  isReadOnly?: boolean;
  isEditableIfNull?: boolean;
  prePopulatedValues?: PrePopulatedValue[] | null;
  id?: number;
  properties?: Record<string, string | null | undefined> | null;
}

export enum GeofenceShapeType {
  CENTROID = 'Centroid',
  POLYGONAL = 'Polygonal',
}

export enum GeofenceTriggerType {
  ENTER = 'ENTER',
  EXIT = 'EXIT',
}

export enum GeofenceDataSource {
  JSON = 'JSON',
  STATIC = 'STATIC',
}

export enum GeofenceUnit {
  FEET = 'FEET',
  METER = 'M',
}

export enum ActionSettingTypeCodes {
  ACCEPT = 'ACCEPT',
  ACCEPTLOAD = 'ACCEPTLOAD',
  BARSCAN = 'BARSCAN',
  CERTIFY_LOGS = 'CERTLOGS',
  COMMIT_OPTIONS = 'COMMITOPTIONS',
  DATETIME = 'DATETIME',
  DECLINE = 'DECLINE',
  DECLINELOAD = 'DECLINELOAD',
  DEVICE_LOCATION = 'DEVICELOCATION',
  DROPDOWN_SELECT = 'DROPDOWN',
  ELD_LOCATION = 'ELDLOCATION',
  GEOFENCE = 'GEOFENCE',
  HEADING_TEXT = 'HEADINGTEXT',
  HYPERLINK = 'HYPERLINK',
  WEBFORM = 'WEBFORM',
  LABEL = 'LABEL',
  PHONE = 'PHONE',
  PUSH = 'PUSH',
  RADIOCHECKBOX = 'RADIOCHECKBOX',
  REJECT = 'REJECT',
  SIDE_BY_SIDE_BUTTONS = 'SIDEBUTTON',
  SIMPLE_BUTTON = 'BUTTON',
  SLIDER = 'SLIDER',
  SMS = 'SMS',
  START = 'START',
  STARTLOAD = 'STARTLOAD',
  STOP = 'STOP',
  SUBMIT_BUTTON = 'SUBMITBUTTON',
  TEMP = 'TEMP',
  TEXT = 'TEXT',
  TFLO_EMAIL = 'TFLOEMAIL',
  TFLO_SMS = 'TFLOSMS',
  TIMER_STOPWATCH = 'TIMER',
}

export enum InputDataType {
  ALPHA = 'ALPHA',
  NUMERIC = 'NUMERIC',
  ALL = 'ALL',
}

export enum InputTextType {
  SHORT = 'SHORT',
  LARGE = 'LARGE',
}

export enum DropdownInputType {
  DDSINGLE = 'DDSINGLE',
  DDMULTI = 'DDMULTI',
}

export enum RadioCheckboxInputType {
  CBSINGLE = 'CBSINGLE',
  CBMULTI = 'CBMULTI',
}

export enum SliderInputType {
  NUMERIC = 'NUMERIC',
  STARS = 'STAR',
}

export const OptionsActions = [
  { label: 'Launch Copilot SDK', value: 'COPILOT' },
  { label: 'Launch email app', value: 'EMAILAPP' },
  { label: 'Launch Geotab SDK', value: 'GEOTAB' },
  { label: 'Launch Phone app', value: 'PHONEAPP' },
  { label: 'Launch Scan SDK', value: 'SCAN' },
  { label: 'Launch SMS', value: 'SMSAPP' },
  { label: 'Launch Web View', value: 'WEBVIEW' },
  { label: 'Send checkcall', value: 'CHECKCALL' },
  { label: 'Send Pre-configured Email', value: 'EMAILCONF' },
  { label: 'Skip Step', value: 'SKIPSTEP' },
];

export const OptionsUnit = [
  { label: 'Feet', value: GeofenceUnit.FEET },
  { label: 'Meter', value: GeofenceUnit.METER },
];

export const ScanParamSources = [
  { label: 'Load JSON', value: 'LOAD_JSON' },
  { label: 'Workflow Components', value: 'WORKFLOW_COMPONENT' },
  { label: 'Deeplink Parameters', value: 'DEEPLINK' },
];

export const DeeplinkParamValues = [
  { label: 'Doctypes', value: 'doctypes' },
  { label: 'Doctype Assign', value: 'doctypeassign' },
  { label: 'Email', value: 'email' },
  { label: 'First Name', value: 'firstname' },
  { label: 'Last Name', value: 'lastname' },
  { label: 'Phone Number', value: 'phonenumber' },
];
